namespace GeniuzPOS.ReportMasterData {
    export class Report_1312Columns {
        static columnsKey = 'ReportMasterData.Report_1312';
    }
}
